"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScriptsConfigBuilder = /** @class */ (function () {
    function ScriptsConfigBuilder(require, pathModuleConfigBuilder, dependenciesModuleConfigBuilder, exportsModuleConfigBuilder) {
        this.require = require;
        this.pathModuleConfigBuilder = pathModuleConfigBuilder;
        this.dependenciesModuleConfigBuilder = dependenciesModuleConfigBuilder;
        this.exportsModuleConfigBuilder = exportsModuleConfigBuilder;
    }
    // ReSharper disable once UnusedParameter
    ScriptsConfigBuilder.prototype.configure = function (modConfig) {
        var paths = this.pathModuleConfigBuilder.build(modConfig);
        var shim = {};
        this.dependenciesModuleConfigBuilder.build(modConfig, shim);
        this.exportsModuleConfigBuilder.build(modConfig, shim);
        paths = paths.map(function (path) {
            return path.substring(0, path.lastIndexOf(".js"));
        });
        this.require.config({
            paths: paths,
            shim: shim
        });
    };
    return ScriptsConfigBuilder;
}());
exports.ScriptsConfigBuilder = ScriptsConfigBuilder;
//# sourceMappingURL=ScriptsConfigBuilder.js.map